export * from './star-rating.component';
export * from './star-rating.module';
